import { StyledContent, StyledButton, StyledTitle, StyledSearchResults } from '@/components/styles'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { useLoadMore, usePartialQuery } from '@/hooks'
import { Search, SearchResult } from '@/components'
import { useRouter } from 'next/router'
import wordEnd from '@/lib/wordEnd'
import api from '@/lib/api'
import { useTranslation } from "react-i18next";

export default function SearchPage(props) {
  const { paginator, searchQuery } = props
  const router = useRouter()
  const { t } = useTranslation("global");

  const queryParams = usePartialQuery(['title'])

  const searchPaginator = useLoadMore(api.search, paginator, queryParams)
  const { items, total, hasMore, handleLoadMore, loading } = searchPaginator

  const handleChange = type => value => {
    const nextQuery = { [type]: value }

    router.push(
      { pathname: router.pathname, query: { ...nextQuery } },
      { pathname: location.pathname, query: { ...nextQuery } },
    )
  }

  return (
    <StyledContent pt="large" pb="large">
      <StyledContent.Container>
        <StyledTitle mb="x-small">{t('search.title')}</StyledTitle>

        <StyledContent.Search>
          <Search onFormSubmit={handleChange('title')} shouldFocus={!items || items.length === 0} />
        </StyledContent.Search>

        <StyledContent.Loadable isLoading={loading}>
          <StyledSearchResults>
            {total > 0 && (
              <StyledSearchResults.Total>
                {total} {wordEnd(total, ['coincidences', 'coincidences', 'coincidences'])}
              </StyledSearchResults.Total>
            )}

            {items && items.length > 0 && (
              <TransitionGroup component={StyledSearchResults.List}>
                {items.map(result => {
                  const { id, ...resultProps } = result
                  return (
                    <CSSTransition
                      in={true}
                      key={id}
                      timeout={{
                        appear: 0,
                        enter: 400,
                        exit: 0,
                      }}
                      classNames="on"
                    >
                      <SearchResult key={id} {...resultProps} />
                    </CSSTransition>
                  )
                })}
              </TransitionGroup>
            )}

            {(!items || items.length === 0) && searchQuery && !loading && (
              <StyledSearchResults.Empty>
                {t('search.empty')}
              </StyledSearchResults.Empty>
            )}

            {hasMore && (
              <StyledSearchResults.LoadBtn>
                <StyledButton light onClick={handleLoadMore}>
                {t('showMore')}
                </StyledButton>
              </StyledSearchResults.LoadBtn>
            )}
          </StyledSearchResults>
        </StyledContent.Loadable>
      </StyledContent.Container>
    </StyledContent>
  )
}
